import { maskFactory } from './helpers';
import { normalizeNotesDiscrete } from '../utils/normalization'; 

export const melodyLineMask = maskFactory(bar => normalizeNotesDiscrete(bar));


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/masks/melodyLineMask.js